import React from 'react';
import cx from 'classnames';
import { Trans } from '@elevio/kb-kit/lib/components/trans';
import LoginLogout from './LoginLogout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { twitterXIcon } from '../utils/constants';
const CONTACT_US = 'https://www.largo.com/connect/contact_the_city/index.php';
const YOUTUBE = 'https://www.youtube.com/user/largotv1/featured';
const FACEBOOK = 'https://www.facebook.com/CityofLargo';
const TWITTER = 'https://x.com/cityoflargo';
const INSTAGRAM = 'https://www.instagram.com/cityoflargo/';
function Footer({ className }) {
    return (<footer className={cx('footer', className)} data-testid="footer">
      <div className="footer-wrapper">
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Comcate, Inc.
        </p>
        <nav className="footer-nav">
          <a className="footer-link" target="_blank" href={CONTACT_US}>
            <Trans>Contact Us</Trans>
          </a>
          <a className="footer-link" target="_blank" href={YOUTUBE}>
            <FontAwesomeIcon icon={faYoutube}/>
          </a>
          <a className="footer-link" target="_blank" href={FACEBOOK}>
            <FontAwesomeIcon icon={faFacebookF}/>
          </a>
          <a className="footer-link x-icon" target="_blank" href={TWITTER}>
            <img src={twitterXIcon} alt="twitterXIcon" height="18px"/>
          </a>
          <a className="footer-link" target="_blank" href={INSTAGRAM}>
            <FontAwesomeIcon icon={faInstagram}/>
          </a>
          <LoginLogout className="footer-link"/>
        </nav>
      </div>
    </footer>);
}
export default Footer;
